import { useEditorRuntimeStore } from '../stores/useEditorRuntimeStore';

export interface Config {
  canvas: {
    areaLimit: number;
    deletingElementOpacity: number;
    fillStyle: string;
    widthHeightLimit: number;
  };
  collision: {
    epsilon: number;
    precision: number;
    threshold: number;
  };
  selection: {
    fillStyle: string;
    handleMargin: number;
    handleSize: number;
    handleSpacing: number;
    rotationResizeHandleGap: number;
    sideResizingThreshold: number;
    strokeStyle: string;
    transformFillStyle: string;
  };
  hover: {
    strokeStyle: string;
    lineWidth: number;
  };
  transformation: {
    rotateLockingAngle: number;
  };
  zoom: {
    maxZoom: number;
    minZoom: number;
    snapPoints: number[];
  };
}

export const COLLISION_EPSILON = 0.00001;
const SELECTION_HANDLE_SPACING = 2;
const SELECTION_SIDE_RESIZING_THRESHOLD = 2 * SELECTION_HANDLE_SPACING;

export const colors = {
  canvasFill: { light: '#E9E9E9', dark: '#2D2D2D' },
  selectionFill: {
    light: 'rgba(0, 0, 200, 0.04)',
    dark: 'rgba(255, 255, 255, 0.04)',
  },
  selectionStroke: { light: '#0085FF', dark: '#0085FF' },
  selectionTransformFill: { light: '#E9E9E9', dark: '#2D2D2D' },
};

export const defaultConfig: Config = {
  canvas: {
    areaLimit: 16_777_216,
    deletingElementOpacity: 0.4,
    fillStyle: colors.canvasFill.light,
    widthHeightLimit: 32_767,
  },
  collision: {
    epsilon: COLLISION_EPSILON,
    precision: 10e-5,
    threshold: 2 * SELECTION_HANDLE_SPACING - COLLISION_EPSILON,
  },
  selection: {
    fillStyle: colors.selectionFill.light,
    handleMargin: 2,
    handleSize: 8,
    handleSpacing: SELECTION_HANDLE_SPACING,
    rotationResizeHandleGap: 16,
    sideResizingThreshold: SELECTION_SIDE_RESIZING_THRESHOLD,
    strokeStyle: colors.selectionStroke.light,
    transformFillStyle: colors.selectionTransformFill.light,
  },
  hover: {
    strokeStyle: colors.selectionStroke.light,
    lineWidth: 2,
  },
  transformation: {
    rotateLockingAngle: Math.PI / 12,
  },
  zoom: {
    maxZoom: 30,
    minZoom: 0.1,
    snapPoints: [0.125, 0.25, 0.5, 1, 2, 4, 8, 16, 32],
  },
};

export const getConfig = () => {
  return useEditorRuntimeStore.getState().config;
};
